export default __webpack_public_path__ + "static/media/product-2.e5302377.png";